import * as constants from './constants';
import { FILTER_KEYS, SORT_DIRECTION as DIRECTIONS, TYPE } from './fixtures';

// const {
//   PAGE,
//   PER_PAGE,
//   TOTAL,
//   CATEGORIES,
//   SORT_BY,
//   SORT_DIRECTION,
//   MANUFACTURERS,
// } = FILTER_KEYS;

// todo - consider move filters/query data to separate reducers
export const initialState = {
  loading: false,
  data: [],
  error: null,
  filters: {
    [FILTER_KEYS.PAGE]: 1,
    [FILTER_KEYS.PER_PAGE]: 20,
    [FILTER_KEYS.HAS_MORE]: false,
    [FILTER_KEYS.SORT_DIRECTION]: DIRECTIONS.DESC,
    [FILTER_KEYS.TYPE]: TYPE.PROJECT,
    // [FILTER_KEYS.QUANTITY]: null,
    [FILTER_KEYS.CATEGORIES]: [],
    [FILTER_KEYS.MANUFACTURERS]: [],
    // [FILTER_KEYS.STORAGE]: [],
    // [FILTER_KEYS.TAGS]: [],
    // [FILTER_KEYS.ITEMS]: [],
  },
};

export const projectItemsReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_PROJECT_ITEMS:
    return {
      ...state,
      loading: true,
    };
  case constants.SET_PROJECT_ITEMS_FILTERS:
    return {
      ...state,
      // data: [],
      filters: {
        ...(action.payload && Object.keys(action.payload).length !== 0 ? {
          ...state.filters,
          ...action.payload,
          [FILTER_KEYS.PAGE]: 1,
          [FILTER_KEYS.HAS_MORE]: false,
        } : JSON.parse(JSON.stringify(initialState.filters))),
      },
    };
  case constants.GET_PROJECT_ITEMS_SUCCESS:
    return {
      ...state,
      loading: false,
      // eslint-disable-next-line max-len
      data: [...(action.payload.filters[FILTER_KEYS.PAGE] !== 1 ? state.data : []), ...action.payload.data],
      filters: {
        ...state.filters,
        ...action.payload.filters,
      },
    };
  case constants.GET_PROJECT_ITEMS_ERROR:
    return {
      ...state,
      loading: false,
      error: action.payload,
      filters: {
        ...state.filters,
        [FILTER_KEYS.HAS_MORE]: false,
      },
    };
  case constants.RESET_PROJECT_ITEMS:
    return initialState;
  default:
    return state;
  }
};

const initialActionState = {
  loading: false,
  selectedIds: [],
  openedItemId: null,
};

export const projectItemsActionReducer = (state = initialActionState, action) => {
  switch (action.type) {
  case constants.SELECT_PROJECT_ITEM:
    return { ...state, selectedIds: [...state.selectedIds, action.payload.id] };
  case constants.DESELECT_PROJECT_ITEM:
    return { ...state, selectedIds: state.selectedIds.filter((id) => id !== action.payload.id) };
  case constants.DESELECT_MANY_PROJECT_ITEMS:
    return {
      ...state,
      selectedIds: state.selectedIds.filter((id) => !action.payload.ids.includes(id)),
    };
  case constants.OPEN_PROJECT_ITEM:
    return { ...state, openedItemId: action.payload.id };
  case constants.CLOSE_PROJECT_ITEM:
    return { ...state, openedItemId: null };
  case constants.RESET_PROJECT_ITEMS_ACTIONS:
    return initialActionState;
  default:
    return state;
  }
};
